import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import {
    ShowMoreAvatarsComponent,
} from '@monsido/modules/report-center/components/show-more-avatars/show-more-avatars.component';
import { SharedModule } from '../../../../shared/shared.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { MonAvatarComponent } from '@client/app/shared/mon-avatar/mon-avatar.component';


@NgModule({
    declarations: [
        ShowMoreAvatarsComponent,
    ],
    imports: [
        CommonModule,
        NgbTooltipModule,
        MonAvatarComponent,
        SharedModule,
        TranslateModule,
    ],
    exports: [
        ShowMoreAvatarsComponent,
    ],
})
export class ShowMoreAvatarsModule { }
